var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lv-base-column',_vm._b({ref:"column",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var rowIndex = ref.rowIndex;
var col = ref.col;
var colIndex = ref.colIndex;
var editRow = ref.editRow;
var fixedRow = ref.fixedRow;
return [_c('link-table-column-toggle-item',_vm._b({attrs:{"row":row,"edit-row":editRow,"row-index":rowIndex,"col":col,"col-index":colIndex,"fixed-row":fixedRow,"size":_vm.size,"color":_vm.color,"true-value":_vm.trueValue,"false-value":_vm.falseValue},nativeOn:{"click":function($event){return _vm.lv_clickItem({row: row,rowIndex: rowIndex,editRow: editRow})}}},'link-table-column-toggle-item',_vm.columnItemBinding,false))]}}])},'lv-base-column',_vm.columnBinding,false))}
var staticRenderFns = []

export { render, staticRenderFns }